module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Gift-da751906ec0fe31719190ff2a85bf5e3.svg";